import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

const WINNER_EXCLUSION_GROUNDS_NOT_ASSESSED = "zz_SourcingEventApiErrorCode_CannotAwardWinnerExclusionGroundsNotAssessed";

export const isUnassessedWinnerRefusal = (e: unknown): boolean =>
  e != null &&
  isFetchBaseQueryError(e) &&
  isApiErrorDto(e.data) &&
  e.data.errorCode === WINNER_EXCLUSION_GROUNDS_NOT_ASSESSED;
